import { render } from "./DailyPage.vue?vue&type=template&id=6b638d5c&scoped=true"
import script from "./DailyPage.vue?vue&type=script&lang=js"
export * from "./DailyPage.vue?vue&type=script&lang=js"

import "./DailyPage.vue?vue&type=style&index=0&id=6b638d5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b638d5c"]])

export default __exports__